import { Box, Button, CircularProgress, Grid, Paper, Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import JobSideBar from '../components/Candidate/JobSideBar';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import companyLogo from '../logo.svg';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getAllJobs } from '../actions/userAuth';
import Layout from '../assets/Layout';

function FindJobs() {
    const [selectedOption, setSelectedOption] = useState('');
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleChange = (e) => {

    };

    useEffect(() => {
        setLoading(true);
        dispatch(getAllJobs({}, (data) => {
            setLoading(false);
            setJobs(data.data);
        }, (err) => {
            setLoading(false);
            console.log(err);
        }))
    }, []);

    const DaysAgo = (date) => {
        if (date) {
            const inputDate = new Date(date);
            const currentDate = new Date();
            const timeDifference = currentDate.getTime() - inputDate.getTime();
            const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return daysAgo;
        }
    }

    return (
        <>
            <Layout>
                <Grid container mt={8}>
                   
                    <Grid item xs={12} md={12} px={3} sx={{ textAlign: 'center' }}>
                        <Typography className='heading1bold' variant="h5">
                        Explore & Seize Your Ideal Opportunity
                        </Typography>
                    </Grid>
                </Grid>
                <Box >
                    <Grid container>
                        <Grid item xs={12} md={3}>
                            <JobSideBar setLoading={setLoading} setJobs={setJobs} />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', my: 4, borderRadius: '10px', mx: 2, }}>
                                <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', mx: 2 }}>Showing {jobs.length} Jobs</Typography>
                                <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', mx: 2, textAlign: 'end' }}>Sort By</Typography>
                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                    className='profile-skills-box text2Light'
                                    value={selectedOption}
                                    onChange={handleChange}
                                >
                                    <option disabled value="">
                                        Sort by date
                                    </option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>

                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                    className='profile-skills-box text2Light'
                                >
                                    <option disabled value="">
                                        Show 10
                                    </option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </Box>
                            {loading
                                ?
                                <CircularProgress />
                                :
                                jobs.map((item, index) => (
                                    <Paper key={index} sx={{ mx: 2, boxShadow: '0px 8px 64px rgba(54, 101, 208, 0.14)', mb: 2 }} >
                                        <Grid container py={2} px={2}>
                                            <Grid item xs={12} md={3}>
                                                <img src={companyLogo} style={{ borderRadius: '1rem' }} width={'100%'} alt='image' />
                                            </Grid>
                                            <Grid item xs={12} md={6} px={2}>
                                                <Stack
                                                    sx={{
                                                        ...(theme.breakpoints.down('md') && {
                                                            my: 2, // Apply vertical margin for mobile view
                                                        }),
                                                    }}>
                                                    <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => navigate('/candidate/job-view/' + item._id)}>{item?.jobTitle}</Typography>
                                                    <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%' }}>{item?.companyName}</Typography>
                                                    <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', opacity: '0.5' }}>{item?.city}, {item?.state}, {item?.country}</Typography>
                                                    <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#2544EE' }}>{item?.companyWebsite}</Typography>
                                                </Stack>
                                            </Grid>
                                            <Grid md={2} sx={{ textAlign: 'right' }}>
                                                <Typography variant="caption" className='tex2Bold' sx={{

                                                    backgroundColor: '#41B249',
                                                    fontWeight: 'bold', width: 'fit-content', color: '#fff',
                                                    borderRadius: '8px', textAlign: 'center', py: 1, px: 3
                                                }}>
                                                    New
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={1} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }} >
                                                <BookmarkBorderIcon />
                                                <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#41B249' }}>{DaysAgo(item.createdAt) == 0 ? "Today" : `${DaysAgo(item.createdAt)} days ago`}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                ))
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Layout>
        </>
    );
}

export default FindJobs;
